export default function sortEligibleFriends(a, b) {
  return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
}